import React from 'react'
import { ReactNode } from 'react'
import HomeActionCard from './HomeActionCard'

interface CardHomeAnalyticsStudentProps {
  title: string
  subtitle: string
  icon: ReactNode
  path?: string
  /** Legado: o card do mockup não tem ilustração. Aceito e ignorado. */
  image?: string
}

/** Card de desempenho do aluno — delega para o card único da Home. */
export default function CardHomeAnalyticsStudent({
  title,
  subtitle,
  icon,
  path,
}: CardHomeAnalyticsStudentProps) {
  return <HomeActionCard icon={icon} title={title} description={subtitle} path={path} />
}
